function DefaultEditorModeManager () {
  this.type = 'default';

  this.hideList = [];
  this.showList = [];
  this.enableList = [];
  this.disableList = [];
}

DefaultEditorModeManager.prototype.initialize = function () {
  this.initialized = true;
  this.tool = INKIVE.Tool.getInstance();
  this.editor = this.tool.editor;
  this.canvas = this.editor.canvas;

  _.bindAll(this, 'enable', 'disable');
};

DefaultEditorModeManager.prototype.enable = function (data) {
  this.initialized || this.initialize();

  this.beforeUIEnable();
  this.enableUI();
  this.afterUIEnable(data);
};

DefaultEditorModeManager.prototype.disable = function () {
  this.initialized || this.initialize();

  this.disableUI();
};

DefaultEditorModeManager.prototype.beforeUIEnable = function () {
  clearTimeout(INKIVE.Tool._autoSaveTimeout);
  INKIVE.Tool._autoSaveTimeout = null;
};

DefaultEditorModeManager.prototype.afterUIEnable = function (data) {
  this.canvas.runExtensions('disableRuler', {});
  this.tool.load(INKIVE.Tool._current_page_number);
};

DefaultEditorModeManager.prototype.enableUI = function () {
  $(this.hideList.join(',')).hide();
  $(this.showList.join(',')).show();
  $(this.enableList.join(',')).removeClass('disabled');
  $(this.disableList.join(',')).addClass('disabled');
};

DefaultEditorModeManager.prototype.disableUI = function () {
  $(this.hideList.join(',')).show();
  $(this.showList.join(',')).hide();
  $(this.enableList.join(',')).addClass('disabled');
  $(this.disableList.join(',')).removeClass('disabled');
};

module.exports = DefaultEditorModeManager;
